module.exports = __webpack_public_path__ + "img/oar-code.baac1a3e.jpg";